class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.closest('[data-main-product]')?.querySelector('product-form');
    this.productSelector = this.closest('[data-main-product]')?.querySelector('product-selector');
  }

  connectedCallback() {
    this.cards = this.querySelectorAll('.po__card');
    this.inputs = this.querySelectorAll('input[name="selling_plan"]');

    this.cards.forEach(card => {
      card.addEventListener('click', this.onCardClick.bind(this));
    });

    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChange.bind(this));
    });

    this.syncState(true);
  }

  onCardClick(event) {
    // Les labels et radios gèrent leur propre sélection (le libellé « S'abonner »
    // pointe déjà vers la fréquence à cocher).
    if (event.target.closest('a, label, input')) return;
    const card = event.currentTarget;
    const inputs = card.querySelectorAll('input[name="selling_plan"]');
    if (Array.from(inputs).some(input => input.checked)) return;
    const input = inputs[0];
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onChange(event) {
    this.classList.remove('has-error');
    this.syncState();
    this.updateProductSelector(event.target.value);
  }

  syncState(isInit) {
    const selected = this.querySelector('input[name="selling_plan"]:checked');
    const hasSellingPlan = !!(selected && selected.value);

    this.cards.forEach(card => {
      const inputs = card.querySelectorAll('input[name="selling_plan"]');
      card.classList.toggle('is-active', Array.from(inputs).some(input => input.checked));
    });

    if (this.productForm) {
      if (hasSellingPlan) {
        this.productForm.setAttribute('data-has-selling-plan', 'true');
      } else {
        this.productForm.removeAttribute('data-has-selling-plan');
      }
      if (!isInit) this.productForm.toggleAddButton(false, '');
    }
  }

  updateProductSelector(sellingPlanId) {
    if (!this.productSelector) return;
    if (typeof this.productSelector.updateURL === 'function') {
      this.productSelector.updateURL(sellingPlanId || null);
    }
    if (typeof this.productSelector.renderProductInfo === 'function') {
      this.productSelector.renderProductInfo();
    }
  }

  isOneTimePurchase() {
    const selected = this.querySelector('input[name="selling_plan"]:checked');
    return !selected || !selected.value;
  }

  showError() {
    this.classList.add('has-error');
  }
}

if (!customElements.get('purchase-options')) {
  customElements.define('purchase-options', PurchaseOptions);
}
